import React, { useState } from "react";
import * as XLSX from "xlsx";
import { Plus, Trash2 } from "lucide-react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import Select from "react-select";
import { Icon } from 'semantic-ui-react';

const ExcelFormulaConfigurator = () => {
  const [fileDataList, setFileDataList] = useState([]);
  const [activeTab, setActiveTab] = useState("File1");
  const [collapsedFormulas, setCollapsedFormulas] = useState({});

const fileOptions = fileDataList.map((_, index) => ({
  value: index,
  label: `File${index + 1}`,
}));

const comparisonOperators = [
  { value: "eq", label: "Equals (A == B)" },
  { value: "neq", label: "Not Equals (A != B)" },
  { value: "gt", label: "Greater Than (A > B)" },
  { value: "lt", label: "Less Than (A < B)" },
  { value: "in", label: "Exists in (A in B list)" },
  { value: "notin", label: "Not Exists in (A not in B list)" },
  { value: "group", label: "Group" },
  { value: "sum", label: "Sum" },
  { label: "Delimiter", value: "delimiter" },
];


  const [formulas, setFormulas] = useState([
    {
      id: 1,
      fileSources: [0],
      columns: [""],
      operations: ["if"],
      targetColumn: "",
      selectedExcelFunction: { value: "numerical_operations", label: "Numerical Operations" },
pivotFile: 0,
pivotRows: [],
pivotColumns: [],
pivotValues: [],
pivotAggregation: "sum",

    },
  ]);
  const [nextId, setNextId] = useState(2);
  const [nextId1, setNextId1] = useState(2);

  const excelFunctions = [
    { value: "numerical_operations", label: "Numerical Operations" },
    { value: "vlookup", label: "VLOOKUP" },
    { value: "sum", label: "SUM" },
    { value: "concat", label: "CONCAT" },
    { value: "boolean_logic", label: "TRUE / FALSE Check" },
    { value: "pivot", label: "Pivot Table" },
    { value: 'consolidate', label: 'Consolidate Sheets' },
    { label: "IF", value: "if" }
  ];

  const Operations= [
    { value: "+", label: "Addition" },
    { value: "-", label: "Subtraction" },
    { value: "*", label: "Multiplication" },
    { value: "/", label: "Divide" },

  ];

const [filters, setFilters] = useState([
  { file: null, sheet: null, column: null, values: [] }
]);



  const addFormula = () => {
    setFormulas((prev) => [
      ...prev,
      {
        id: nextId,
        fileSources: [0],
        columns: [""],
        operations: ["+"],
        targetColumn: "",
        selectedExcelFunction: { value: "numerical_operations", label: "Numerical Operations" },
      },
    ]);
    setNextId((prev) => prev + 1);
  };

  const updateFormula = (id, field, value) => {
    setFormulas((prev) =>
      prev.map((f) => (f.id === id ? { ...f, [field]: value } : f))
    );
  };

const updateIfCondition = (formulaId, index, field, value) => {
  setFormulas((prev) =>
    prev.map((f) => {
      if (f.id === formulaId) {
        const updatedConditions = [...(f.booleanConditions || [])];
        updatedConditions[index] = {
          ...updatedConditions[index],
          [field]: value,
        };
        return {
          ...f,
          booleanConditions: updatedConditions,
        };
      }
      return f;
    })
  );
};


const addColumnPair = (id) => {
  setFormulas((prev) =>
    prev.map((f) => {
      if (f.id !== id) return f;
      console.log("f",f)

      if (f.selectedExcelFunction.value === "numerical_operations") {
        return {
          ...f,
          fileSources: [...f.fileSources, 0],
          columns: [...f.columns, ""],
          operations: [...f.operations, "+"],
        };
      } else if (f.selectedExcelFunction?.value === "if") {
        return {
          ...f,
          booleanConditions: [
            ...(f.booleanConditions || []),
            {
              file: null,
              sheet: null,
              columnA: null,
              condition: "eq",
              compareFile: null,
              compareSheet: null,
              columnB: null,
            },
          ],
        };
      } else if (f.selectedExcelFunction.value === "consolidate") {
        return {
          ...f,
          consolidationFilters: [
            ...(f.consolidationFilters || []),
            {
              file: null,
              sheet: null,
              column: null,
              values: [],
              availableValues: [],
            },
          ],
        };
      }  else if (f.selectedExcelFunction.value === "sum") {
        return {
          ...f,
          sumSegments: [
            ...(f.sumSegments || []),
            { file: "", from: "", to: "" },
          ],
        };
      }

      return f; // fallback
    })
  );
};



const removeColumnPair = (id, index) => {
  setFormulas((prev) =>
    prev.map((f) => {
      if (f.id === id) {
        const updated = { ...f };

        if (f.selectedExcelFunction?.value === "numerical_operations") {
          updated.fileSources = [...f.fileSources];
          updated.columns = [...f.columns];
          updated.operations = [...f.operations];
          updated.fileSources.splice(index, 1);
          updated.columns.splice(index, 1);
          updated.operations.splice(index, 1);
        } else if (f.selectedExcelFunction?.value === "consolidate") {
          updated.consolidationFilters = [...(f.consolidationFilters || [])];
          updated.consolidationFilters.splice(index, 1);
        }

        return updated;
      }
      return f;
    })
  );
};

const addSumSegment = (formulaId) => {
  setFormulas(prev =>
    prev.map(f =>
      f.id === formulaId
        ? { ...f, sumSegments: [...(f.sumSegments || []), { file: "", from: "", to: "" }] }
        : f
    )
  );
};

const getSheetOptions = (fileName) =>
  fileDataList[fileName]?.sheetNames?.map(sheet => ({
    label: sheet,
    value: sheet,
  })) || [];

const getColumnOptions = (fileName, sheetName) => {
  const data = fileDataList[fileName]?.sheetData?.[sheetName];
  if (!data || data.length === 0) return [];
  return Object.keys(data[0]).map(col => ({ label: col, value: col }));
};

const getUniqueValues = (fileName, sheetName, columnName) => {
  const data = fileDataList[fileName]?.sheetData?.[sheetName] || [];
  const unique = [...new Set(data.map(row => row[columnName]))].filter(Boolean);
  return unique.map(val => ({ label: String(val), value: String(val) }));
};

const handleFilterChange = (index, key, value) => {
  const updated = [...filters];
  updated[index][key] = value;

  if (key === "file") {
    updated[index].sheet = null;
    updated[index].column = null;
    updated[index].values = [];
  } else if (key === "sheet") {
    updated[index].column = null;
    updated[index].values = [];
  } else if (key === "column") {
    updated[index].values = [];
  }

  setFilters(updated);
};

const handleValueChange = (index, selectedValues) => {
  const updated = [...filters];
  updated[index].values = selectedValues;
  setFilters(updated);
};

const updateConsolidationFilter = (formulaId, index, key, value) => {
  setFormulas((prev) =>
    prev.map((f) =>
      f.id === formulaId
        ? {
            ...f,
            consolidationFilters: f.consolidationFilters.map((filter, i) =>
              i === index ? { ...filter, [key]: value } : filter
            ),
          }
        : f
    )
  );
};



const addFilterRow = () => {
  setFilters([
    ...filters,
    {
      id: nextId1, // or use uuid() for better uniqueness
      file: null,
      sheet: null,
      column: null,
      values: []
    }
  ]);
  setNextId1(nextId1+1);
};


const updateSegment = (formulaId, idx, key, value) => {
  setFormulas(prev =>
    prev.map(f => {
      if (f.id !== formulaId) return f;
      const updatedSegments = [...f.sumSegments];
      updatedSegments[idx][key] = value;
      return { ...f, sumSegments: updatedSegments };
    })
  );
};

const removeSumSegment = (formulaId, idx) => {
  setFormulas(prev =>
    prev.map(f => {
      if (f.id !== formulaId) return f;
      const updatedSegments = f.sumSegments.filter((_, i) => i !== idx);
      return { ...f, sumSegments: updatedSegments };
    })
  );
};



  const removeFormula = (id) => {
    setFormulas((prev) => prev.filter((f) => f.id !== id));
  };

const handleFileUpload = (e, index) => {
  const file = e.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (evt) => {
    const bstr = evt.target.result;
    const wb = XLSX.read(bstr, { type: "binary" });
    const MAX_PREVIEW_ROWS = 20;


    const sheetNames = wb.SheetNames;
    const sheetDataMap = {};

    sheetNames.forEach(sheet => {
      const ws = wb.Sheets[sheet];
      const rawData = XLSX.utils.sheet_to_json(ws, { header: 1 });

      let headers = [];
      let dataStartIndex = 0;

      for (let i = 0; i < rawData.length; i++) {
        const row = rawData[i] || [];
        const nonEmptyValues = row.filter(cell => cell !== undefined && cell !== null && cell !== "").length;
        if (nonEmptyValues > 4) {
          headers = row;
          dataStartIndex = i + 1;
          break;
        }
      }

      const data = rawData.slice(dataStartIndex).map(row =>
        Object.fromEntries(headers.map((h, i) => [h, row[i] ?? ""]))
      );

      sheetDataMap[sheet] = data;
    });

    const newList = [...fileDataList];
    newList[index] = {
      name: file.name,
      originalFile: file,    // ? Add this line to save the real file
      fileBinary: bstr,       // (optional if you still want to keep)
      sheetNames,
      selectedSheetPerFormula: {},
      sheetData: sheetDataMap,
    };

    setFileDataList(newList);
  };

  reader.readAsBinaryString(file);
};

  const addFileInput = () => {
    setFileDataList([...fileDataList, { name: "", data: [] }]);
  };

  const removeFile = (index) => {
    const updated = [...fileDataList];
    updated.splice(index, 1);
    setFileDataList(updated);
    if (activeTab === `File${index + 1}` && fileDataList.length > 1) {
      setActiveTab(`File1`);
    }
  };

const removeIfConditionRow = (formulaId, indexToRemove) => {
  setFormulas((prev) =>
    prev.map((f) => {
      if (f.id === formulaId) {
        const updatedConditions = [...(f.booleanConditions || [])];
        updatedConditions.splice(indexToRemove, 1);
        return {
          ...f,
          booleanConditions: updatedConditions,
        };
      }
      return f;
    })
  );
};


const handleDownload = async () => {
  // setLoading(true);

  const formData = new FormData();

  // 1?? Attach all files (binary)
  fileDataList.forEach((fileData, index) => {
    if (fileData.originalFile) {
      formData.append(`file${index}`, fileData.originalFile);
    }
  });

  // 2?? Attach formulas (as JSON)
  formData.append('formulas', JSON.stringify(formulas));

  try {
    // 3?? Send POST request to backend
    const response = await fetch('http://172.16.40.14:5101/api/v2/bsr/process/', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      console.error('Server returned error:', response.status);
      // setLoading(false);
      return;
    }

    // 4?? Receive processed file (as Blob)
    const blob = await response.blob();

    // 5?? Create download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'processed_output.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    console.log('Download completed.');

  } catch (error) {
    console.error('Processing failed:', error);
  } finally {
    console.error('Processing done');
    //setLoading(false);
  }
};

  return (
    <div className="p-6 bg-gray-100 min-h-screen" style = {{padding : "10px"}}>
      <h2 className="pt-1 pb-1 text-center">Formula Configurator</h2>

      {/* File Inputs */}
      <div className="flex flex-wrap gap-4 mb-6" style = {{display:"flex"}}>
        {fileDataList.map((file, index) => (
          <div key={index} className="bg-white shadow p-4 rounded-xl w-60"       style={{
        width: "15%", // ensures 5 blocks per row
        minWidth: "300px", // optional: keeps boxes from becoming too small on narrow screens
        boxSizing: "border-box"
      }}>
            <label className="block mb-2 font-semibold text-gray-700">
              File {index + 1}
            </label>
<div style = {{display: "flex"}}>
<div>
            <input
              type="file"
              accept=".csv, .xlsx"
              onChange={(e) => handleFileUpload(e, index)}
              className="mb-3 w-full text-sm file:bg-blue-600 file:text-white file:px-2 file:py-1 file:rounded file:border-none"
              style={{ width: "220px",marginRight:"5px" }}
            />
</div>
<div style = {{paddingTop:"2px"}}>
            <button
              onClick={() => removeFile(index)}
              className="flex items-center justify-center gap-2 text-white px-3 py-2 rounded"
              style={{ backgroundColor: "#000055",height:"30px" }}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
</div>
</div>
          </div>
        ))}

        {fileDataList.length < 100 && (
          <button
            onClick={addFileInput}
            className="flex flex-col items-center justify-center text-white px-3 py-2 rounded w-28 h-28"
            style={{ backgroundColor: "#000055",height:"35px" }}
          >
            <Plus className="text-3xl text-white" />
            <span className="mt-2 text-sm font-medium">Add File</span>
          </button>
        )}
      </div>

      {/* Tab View 
      <div className="flex space-x-2 mb-4">
        {fileDataList.map((_, i) => (
          <button
            key={i}
            className={`px-4 py-2 rounded ${activeTab === `File${i + 1}` ? "bg-blue-600 text-white" : "bg-gray-300"}`}
            onClick={() => setActiveTab(`File${i + 1}`)}
          >
            File{i + 1}
          </button>
        ))}
      </div> */}

      {/* Data Preview 
      {fileDataList[parseInt(activeTab.replace("File", "")) - 1]?.data.length > 0 && (
        <div className="overflow-auto max-h-60 border mb-6 bg-white rounded">
          <table className="min-w-full border-collapse">
            <thead className="bg-gray-200 sticky top-0 z-10">
              <tr>
                {Object.keys(fileDataList[parseInt(activeTab.replace("File", "")) - 1].data[0]).map((header, i) => (
                  <th key={i} className="px-3 py-2 border text-left font-medium text-sm">{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {fileDataList[parseInt(activeTab.replace("File", "")) - 1].data.map((row, i) => (
                <tr key={i} className="odd:bg-white even:bg-gray-50">
                  {Object.values(row).map((val, j) => (
                    <td key={j} className="px-3 py-2 border text-sm">{val}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )} */}

      {/* Formula Configuration */}
      <h3 className="text-xl font-semibold mb-4">Formula Configuration</h3>
{formulas.map((formula, index) => {
  const isCollapsed = collapsedFormulas[formula.id];

  return (
    <div key={formula.id}>
      {/* Header with toggle */}
      <div style = {{margin:"10px"}}>
        <h3 onClick={() =>
            setCollapsedFormulas((prev) => ({
              ...prev,
              [formula.id]: !prev[formula.id],
            }))
}
          style={{ cursor: "pointer", color: "#4969ab" }}>
          Formula {index + 1} {isCollapsed ? '+' : '-'}
        </h3>
</div>



      {!isCollapsed && (
        <div className="bg-white shadow p-4 rounded-xl mb-4">
          <div className="flex flex-wrap gap-3 items-center" style = {{display : "flex"}}>
            <div>
              <label className="label1 mb-1">Target Column</label><br />
             <div className="form-input">  
              <input
                type="text"
                value={formula.targetColumn}
                onChange={(e) => updateFormula(formula.id, "targetColumn", e.target.value)}
                placeholder="Target Column Name"
                 style={{
                      flex: 1,
                      padding: '5px',
                      marginLeft: "5px",
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      height : "37px"
                    }}
              />
            </div>
            </div>

            <div>
              <label className="label1 mb-1">Function</label><br />
              <Select
                options={excelFunctions}
                value={formula.selectedExcelFunction}
                onChange={(selected) => {
      if (selected.value === 'consolidate') {
        const alreadyExists = formulas.some(f => f.selectedExcelFunction?.value === 'consolidate');
        if (alreadyExists) {
          alert("Only one Consolidated Sheet is allowed. Please modify the existing one.");
          return;
        }
      }
      updateFormula(formula.id, "selectedExcelFunction", selected);
    }}
              />
            </div>

            <div className="pt-6" style = {{height : "30px",paddingTop:"25px"}}>
                  <Icon
                    name="plus"
                    style={{ cursor: "pointer", marginLeft: "10px", color: "green" }}
                    onClick={() => addColumnPair(formula.id)}
                  />
            </div>

            <div className="pt-6" style = {{height : "30px",paddingTop:"25px"}}>
                  <Icon
                    name="trash"
                    style={{ cursor: "pointer", marginLeft: "10px", color: "red" }}
                    onClick={() => removeFormula(formula.id)}
                  />
            </div>
          </div>
{formula.selectedExcelFunction?.value === "consolidate" &&
  (formula.consolidationFilters || []).map((filter, index) => (
    <div
      key={index} style = {{display:"flex"}}
      className="flex flex-wrap gap-4 pt-4 items-end border p-2 mb-2 rounded bg-gray-50"
    >
      {/* File selector */}
      <div>
        <label className="label1 mb-1">File</label><br />
        <Select
          options={fileOptions}
          value={fileOptions.find(opt => opt.value === filter.file)}
          onChange={(selected) =>
            updateConsolidationFilter(formula.id, index, "file", selected.value)
          }
          className="text-sm w-36"
          placeholder="Select File"
        />
      </div>

      {/* Sheet selector */}
      <div>
        <label className="label1 mb-1">Sheet</label><br />
        <Select
          options={fileDataList[filter.file]?.sheetNames?.map(sheet => ({ value: sheet, label: sheet })) || []}
          value={filter.sheet ? { value: filter.sheet, label: filter.sheet } : null}
          onChange={(selected) => {
            const updated = [...fileDataList];
            if (!updated[filter.file].selectedSheetPerFormula) {
              updated[filter.file].selectedSheetPerFormula = {};
            }
            updated[filter.file].selectedSheetPerFormula[`${formula.id}_consolidation_${index}`] = selected.value;
            setFileDataList(updated);
            updateConsolidationFilter(formula.id, index, "sheet", selected.value);
          }}
          className="text-sm w-36"
          placeholder="Select Sheet"
        />
      </div>

      {/* Column Selector */}
      <div>
        <label className="label1 mb-1">Filter Column</label><br />
        <Select
          options={(() => {
            const file = fileDataList[filter.file];
            const sheet = file?.selectedSheetPerFormula?.[`${formula.id}_consolidation_${index}`];
            const row = file?.sheetData?.[sheet]?.[0];
            return row ? Object.keys(row).map(col => ({ value: col, label: col })) : [];
          })()}
          value={filter.column ? { value: filter.column, label: filter.column } : null}
          onChange={(selectedOption) => {
            updateConsolidationFilter(formula.id, index, "column", selectedOption.value);

            // Auto-populate available values
            const file = fileDataList[filter.file];
            const sheet = file?.selectedSheetPerFormula?.[`${formula.id}_consolidation_${index}`];
            const data = file?.sheetData?.[sheet] || [];
            const uniqueValues = [...new Set(data.map(row => row[selectedOption.value]))]
              .filter(v => v !== undefined && v !== null)
              .map(v => ({ value: v, label: String(v) }));

            updateConsolidationFilter(formula.id, index, "availableValues", uniqueValues);
            updateConsolidationFilter(formula.id, index, "values", []); // reset values
          }}
          className="text-sm w-64"
          placeholder="Select Column"
        />
      </div>

      {/* Unique Values Multi-Select */}
      {filter.availableValues?.length > 0 && (
        <div>
          <label className="label1 mb-1">Select Values</label><br />
          <Select
            isMulti
            options={filter.availableValues}
            value={(filter.values || []).map(v => ({ value: v, label: v }))}
            onChange={(selectedOptions) =>
              updateConsolidationFilter(formula.id, index, "values", selectedOptions.map(opt => opt.value))
            }
            className="text-sm w-64"
            placeholder="Select Values"
          />
        </div>
      )}
{index > 0 && (
  <Icon
    name="trash"
    style={{ cursor: "pointer", marginLeft: "10px", color: "red", paddingTop: "35px" }}
    onClick={() => removeColumnPair(formula.id, index)}
  />
)}
    </div>
))}

{formula.selectedExcelFunction?.value === "boolean_logic" && (
  <div className="flex flex-wrap gap-4 pt-4" style={{display:"flex"}}>
    {/* File Selector */}
    <div>
      <label className="label1 mb-1">File</label><br />
      <Select
        options={fileOptions}
        value={fileOptions.find(opt => opt.value === formula.booleanFile)}
        onChange={(selected) => updateFormula(formula.id, "booleanFile", selected.value)}
        className="text-sm w-36"
      />
    </div>

    {/* Sheet Selector */}
    <div>
      <label className="label1 mb-1">Sheet</label><br />
      <Select
        options={fileDataList[formula.booleanFile]?.sheetNames?.map(s => ({ value: s, label: s })) || []}
        value={
          fileDataList[formula.booleanFile]?.selectedSheetPerFormula?.[`${formula.id}_bool`]
            ? {
                value: fileDataList[formula.booleanFile].selectedSheetPerFormula[`${formula.id}_bool`],
                label: fileDataList[formula.booleanFile].selectedSheetPerFormula[`${formula.id}_bool`],
              }
            : null
        }
        onChange={(selected) => {
          const updated = [...fileDataList];
          if (!updated[formula.booleanFile].selectedSheetPerFormula) {
            updated[formula.booleanFile].selectedSheetPerFormula = {};
          }
          updated[formula.booleanFile].selectedSheetPerFormula[`${formula.id}_bool`] = selected.value;
          setFileDataList(updated);
        }}
        className="text-sm w-36"
      />
    </div>

    {/* Column A */}
    <div>
      <label className="label1 mb-1">Column A</label><br />
      <Select
        options={
          (() => {
            const file = fileDataList[formula.booleanFile];
            const sheet = file?.selectedSheetPerFormula?.[`${formula.id}_bool`];
            const row = file?.sheetData?.[sheet]?.[0];
            return row ? Object.keys(row).map(col => ({ value: col, label: col })) : [];
          })()
        }
        value={
          formula.booleanColumnA
            ? { value: formula.booleanColumnA, label: formula.booleanColumnA }
            : null
        }
        onChange={(selected) => updateFormula(formula.id, "booleanColumnA", selected.value)}
        className="text-sm w-36"
        placeholder="Select Column A"
      />
    </div>

    {/* Column B */}
    <div>
      <label className="label1 mb-1">Column B</label><br />
      <Select
        options={
          (() => {
            const file = fileDataList[formula.booleanFile];
            const sheet = file?.selectedSheetPerFormula?.[`${formula.id}_bool`];
            const row = file?.sheetData?.[sheet]?.[0];
            return row ? Object.keys(row).map(col => ({ value: col, label: col })) : [];
          })()
        }
        value={
          formula.booleanColumnB
            ? { value: formula.booleanColumnB, label: formula.booleanColumnB }
            : null
        }
        onChange={(selected) => updateFormula(formula.id, "booleanColumnB", selected.value)}
        className="text-sm w-36"
        placeholder="Select Column B"
      />
    </div>

    {/* Comparison */}
    <div>
      <label className="label1 mb-1">Condition</label><br />
      <Select
        options={[
          { value: "eq", label: "Equals (A == B)" },
          { value: "neq", label: "Not Equals (A != B)" },
          { value: "gt", label: "Greater Than (A > B)" },
          { value: "lt", label: "Less Than (A < B)" },
        ]}
        value={
          formula.booleanCondition
            ? {
                value: formula.booleanCondition,
                label:
                  formula.booleanCondition === "eq" ? "Equals (A == B)" :
                  formula.booleanCondition === "neq" ? "Not Equals (A ? B)" :
                  formula.booleanCondition === "gt" ? "Greater Than (A > B)" :
                  "Less Than (A < B)"
              }
            : null
        }
        onChange={(selected) => updateFormula(formula.id, "booleanCondition", selected.value)}
        className="text-sm w-48"
      />
    </div>
  </div>
)}



{formula.selectedExcelFunction?.value === "sum" && (
  <div className="flex flex-col gap-4">
    {formula.sumSegments?.map((segment, idx) => (
      <div key={idx} className="flex items-center gap-3" style={{ display: "flex", flexWrap: "wrap" }}>
                  {idx > 0 && (
                   <div>
                     <label className="label1 mb-1">Operations</label><br />
                     <Select
                       options={Operations}
                       value={Operations.find(opt => opt.value === segment.operations)}
                       onChange={(selected) => updateSegment(formula.id, idx, "operations", selected.value)}
                     />
                   </div>
                  )}

        <div>
          <label className="label1 mb-1">File</label><br />
          <Select
            options={fileOptions}
            value={fileOptions.find(opt => opt.value === segment.file)}
            onChange={(selected) => updateSegment(formula.id, idx, "file", selected.value)}
            className="text-sm w-36"
          />
        </div>

        {/* Sheet selector */}
        <div>
          <label className="label1 mb-1">Sheet</label><br />
          <Select
            options={
              fileDataList[segment.file]?.sheetNames?.map(name => ({ value: name, label: name })) || []
            }
            value={
              fileDataList[segment.file]?.selectedSheetPerFormula?.[`${formula.id}_sum_${segment.file}_${idx}`]
                ? {
                    value: fileDataList[segment.file].selectedSheetPerFormula[`${formula.id}_sum_${segment.file}_${idx}`],
                    label: fileDataList[segment.file].selectedSheetPerFormula[`${formula.id}_sum_${segment.file}_${idx}`]
                  }
                : null
            }
            onChange={(selected) => {
              const updated = [...fileDataList];
              if (!updated[segment.file].selectedSheetPerFormula) {
                updated[segment.file].selectedSheetPerFormula = {};
              }
              updated[segment.file].selectedSheetPerFormula[`${formula.id}_sum_${segment.file}_${idx}`] = selected.value;
              setFileDataList(updated);
            }}
            className="text-sm w-36"
          />
        </div>

        {/* From Column */}
        <div>
          <label className="label1 mb-1">From</label><br />
          <Select
            options={
              (() => {
                const file = fileDataList[segment.file];
                const sheet = file?.selectedSheetPerFormula?.[`${formula.id}_sum_${segment.file}_${idx}`];
                const row = file?.sheetData?.[sheet]?.[0];
                return row ? Object.keys(row).map(col => ({ value: col, label: col })) : [];
              })()
            }
            value={{ label: segment.from, value: segment.from }}
            onChange={(selected) => updateSegment(formula.id, idx, "from", selected.value)}
            className="text-sm w-36"
          />
        </div>

        {/* To Column */}
        <div>
          <label className="label1 mb-1">To</label><br />
          <Select
            options={
              (() => {
                const file = fileDataList[segment.file];
                const sheet = file?.selectedSheetPerFormula?.[`${formula.id}_sum_${segment.file}_${idx}`];
                const row = file?.sheetData?.[sheet]?.[0];
                return row ? Object.keys(row).map(col => ({ value: col, label: col })) : [];
              })()
            }
            value={{ label: segment.to, value: segment.to }}
            onChange={(selected) => updateSegment(formula.id, idx, "to", selected.value)}
            className="text-sm w-36"
          />
        </div>

        {/* Remove button */}
        <Icon
          name="trash"
          style={{ cursor: "pointer", marginLeft: "10px", color: "red", paddingTop: "35px" }}
          onClick={() => removeSumSegment(formula.id, idx)}
        />

      </div>
    ))}
  </div>
)}

{formula.selectedExcelFunction?.value === "vlookup" && (
  <div className="flex flex-wrap gap-3 pt-4" style={{ paddingRight: "5px", paddingTop: "5px" }}>
    
    {/* Reference File + Sheet + Column */}
    <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
      <div>
        <label className="label1 mb-1">Reference File</label><br />
        <Select
          options={fileOptions}
          value={fileOptions.find(option => option.value === formula.vlookupFile)}
          onChange={(selectedOption) => updateFormula(formula.id, "vlookupFile", selectedOption.value)}
          className="text-sm w-36"
        />
      </div>

      <div>
        <label className="label1 mb-1">Reference Sheet</label><br />
        <Select
          options={
            fileDataList[formula.vlookupFile]?.sheetNames?.map(s => ({ value: s, label: s })) || []
          }
          value={
            fileDataList[formula.vlookupFile]?.selectedSheetPerFormula?.[`${formula.id}_vlookup_ref`]
              ? {
                  value: fileDataList[formula.vlookupFile].selectedSheetPerFormula[`${formula.id}_vlookup_ref`],
                  label: fileDataList[formula.vlookupFile].selectedSheetPerFormula[`${formula.id}_vlookup_ref`],
                }
              : null
          }
          onChange={(selected) => {
            const updated = [...fileDataList];
            if (!updated[formula.vlookupFile].selectedSheetPerFormula)
              updated[formula.vlookupFile].selectedSheetPerFormula = {};
            updated[formula.vlookupFile].selectedSheetPerFormula[`${formula.id}_vlookup_ref`] = selected.value;
            setFileDataList(updated);
          }}
          className="text-sm w-36"
        />
      </div>

      <div>
        <label className="label1 mb-1">Reference Column</label><br />
        <Select
          options={
            (() => {
              const file = fileDataList[formula.vlookupFile];
              const sheet = file?.selectedSheetPerFormula?.[`${formula.id}_vlookup_ref`];
              const row = file?.sheetData?.[sheet]?.[0];
              return row ? Object.keys(row).map(col => ({ value: col, label: col })) : [];
            })()
          }
          value={
            formula.vlookupRefCol
              ? { value: formula.vlookupRefCol, label: formula.vlookupRefCol }
              : null
          }
          onChange={(selectedOption) =>
            updateFormula(formula.id, "vlookupRefCol", selectedOption.value)
          }
          placeholder="Reference Column"
        />
      </div>
    </div>

    {/* Range File + Sheet + Columns */}
    <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "10px" }}>
      <div>
        <label className="label1 mb-1">Range File</label><br />
        <Select
          options={fileOptions}
          value={fileOptions.find(option => option.value === formula.vlookupRangeFile)}
          onChange={(selectedOption) =>
            updateFormula(formula.id, "vlookupRangeFile", selectedOption.value)
          }
          className="text-sm w-36"
        />
      </div>

      <div>
        <label className="label1 mb-1">Range Sheet</label><br />
        <Select
          options={
            fileDataList[formula.vlookupRangeFile]?.sheetNames?.map(s => ({ value: s, label: s })) || []
          }
          value={
            fileDataList[formula.vlookupRangeFile]?.selectedSheetPerFormula?.[`${formula.id}_vlookup_range`]
              ? {
                  value: fileDataList[formula.vlookupRangeFile].selectedSheetPerFormula[`${formula.id}_vlookup_range`],
                  label: fileDataList[formula.vlookupRangeFile].selectedSheetPerFormula[`${formula.id}_vlookup_range`],
                }
              : null
          }
          onChange={(selected) => {
            const updated = [...fileDataList];
            if (!updated[formula.vlookupRangeFile].selectedSheetPerFormula)
              updated[formula.vlookupRangeFile].selectedSheetPerFormula = {};
            updated[formula.vlookupRangeFile].selectedSheetPerFormula[`${formula.id}_vlookup_range`] = selected.value;
            setFileDataList(updated);
          }}
          className="text-sm w-36"
        />
      </div>

      <div>
        <label className="label1 mb-1">Column From</label><br />
        <Select
          options={
            (() => {
              const file = fileDataList[formula.vlookupRangeFile];
              const sheet = file?.selectedSheetPerFormula?.[`${formula.id}_vlookup_range`];
              const row = file?.sheetData?.[sheet]?.[0];
              return row ? Object.keys(row).map(col => ({ value: col, label: col })) : [];
            })()
          }
          value={
            formula.vlookupColFrom
              ? { value: formula.vlookupColFrom, label: formula.vlookupColFrom }
              : null
          }
          onChange={(selectedOption) =>
            updateFormula(formula.id, "vlookupColFrom", selectedOption.value)
          }
          placeholder="From Column"
        />
      </div>

      <div>
        <label className="label1 mb-1">Column To</label><br />
        <Select
          options={
            (() => {
              const file = fileDataList[formula.vlookupRangeFile];
              const sheet = file?.selectedSheetPerFormula?.[`${formula.id}_vlookup_range`];
              const row = file?.sheetData?.[sheet]?.[0];
              return row ? Object.keys(row).map(col => ({ value: col, label: col })) : [];
            })()
          }
          value={
            formula.vlookupColTo
              ? { value: formula.vlookupColTo, label: formula.vlookupColTo }
              : null
          }
          onChange={(selectedOption) =>
            updateFormula(formula.id, "vlookupColTo", selectedOption.value)
          }
          placeholder="To Column"
        />
      </div>

      <div>
        <label className="label1 mb-1">Return Column</label><br />
        <Select
          options={
            (() => {
              const file = fileDataList[formula.vlookupRangeFile];
              const sheet = file?.selectedSheetPerFormula?.[`${formula.id}_vlookup_range`];
              const row = file?.sheetData?.[sheet]?.[0];
              return row ? Object.keys(row).map(col => ({ value: col, label: col })) : [];
            })()
          }
          value={
            formula.vlookupReturnCol
              ? { value: formula.vlookupReturnCol, label: formula.vlookupReturnCol }
              : null
          }
          onChange={(selectedOption) =>
            updateFormula(formula.id, "vlookupReturnCol", selectedOption.value)
          }
          placeholder="Return Column"
        />
      </div>

      <div>
        <label className="label1 mb-1">Match Type</label><br />
        <Select
          options={[
            { label: "FALSE (Exact Match)", value: false },
            { label: "TRUE (Approx. Match)", value: true }
          ]}
          value={
            typeof formula.vlookupExactMatch === "boolean"
              ? {
                  value: formula.vlookupExactMatch,
                  label: formula.vlookupExactMatch ? "TRUE (Approx. Match)" : "FALSE (Exact Match)"
                }
              : null
          }
          onChange={(selectedOption) =>
            updateFormula(formula.id, "vlookupExactMatch", selectedOption.value)
          }
          placeholder="Match Type"
          className="text-sm w-44"
        />
      </div>
    </div>
  </div>
)}

{formula.selectedExcelFunction?.value === "pivot" && (
  <div className="flex flex-wrap gap-4 pt-4" style={{display:"flex"}}>

    {/* File selector */}
    <div>
      <label className="label1 mb-1">File</label><br />
      <Select
        options={fileOptions}
        value={fileOptions.find(opt => opt.value === formula.pivotFile)}
        onChange={(selected) => updateFormula(formula.id, "pivotFile", selected.value)}
        className="text-sm w-36"
      />
    </div>

    {/* Sheet selector */}
    <div>
      <label className="label1 mb-1">Sheet</label><br />
      <Select
        options={fileDataList[formula.pivotFile]?.sheetNames?.map(sheet => ({ value: sheet, label: sheet })) || []}
        value={
          fileDataList[formula.pivotFile]?.selectedSheetPerFormula?.[`${formula.id}_pivot`]
            ? { value: fileDataList[formula.pivotFile].selectedSheetPerFormula[`${formula.id}_pivot`], label: fileDataList[formula.pivotFile].selectedSheetPerFormula[`${formula.id}_pivot`] }
            : null
        }
        onChange={(selected) => {
          const updated = [...fileDataList];
          if (!updated[formula.pivotFile].selectedSheetPerFormula) {
            updated[formula.pivotFile].selectedSheetPerFormula = {};
          }
          updated[formula.pivotFile].selectedSheetPerFormula[`${formula.id}_pivot`] = selected.value;
          setFileDataList(updated);
        }}
        className="text-sm w-36"
        placeholder="Select Sheet"
      />
    </div>

    {/* Row fields */}
    <div>
      <label className="label1 mb-1">Row Fields</label><br />
      <Select
        isMulti
        options={
          (() => {
            const file = fileDataList[formula.pivotFile];
            const sheet = file?.selectedSheetPerFormula?.[`${formula.id}_pivot`];
            const row = file?.sheetData?.[sheet]?.[0];
            return row ? Object.keys(row).map(col => ({ value: col, label: col })) : [];
          })()
        }
        value={(formula.pivotRows || []).map(col => ({ value: col, label: col }))}
        onChange={(selectedOptions) =>
          updateFormula(formula.id, "pivotRows", selectedOptions.map(opt => opt.value))
        }
        className="text-sm w-64"
        placeholder="Select Row Fields"
      />
    </div>

    {/* Column fields (optional) */}
    <div>
      <label className="label1 mb-1">Column Fields</label><br />
      <Select
        isMulti
        options={
          (() => {
            const file = fileDataList[formula.pivotFile];
            const sheet = file?.selectedSheetPerFormula?.[`${formula.id}_pivot`];
            const row = file?.sheetData?.[sheet]?.[0];
            return row ? Object.keys(row).map(col => ({ value: col, label: col })) : [];
          })()
        }
        value={(formula.pivotColumns || []).map(col => ({ value: col, label: col }))}
        onChange={(selectedOptions) =>
          updateFormula(formula.id, "pivotColumns", selectedOptions.map(opt => opt.value))
        }
        className="text-sm w-64"
        placeholder="Select Column Fields (Optional)"
      />
    </div>

    {/* Value fields */}
    <div>
      <label className="label1 mb-1">Value Fields</label><br />
      <Select
        isMulti
        options={
          (() => {
            const file = fileDataList[formula.pivotFile];
            const sheet = file?.selectedSheetPerFormula?.[`${formula.id}_pivot`];
            const row = file?.sheetData?.[sheet]?.[0];
            return row ? Object.keys(row).map(col => ({ value: col, label: col })) : [];
          })()
        }
        value={(formula.pivotValues || []).map(col => ({ value: col, label: col }))}
        onChange={(selectedOptions) =>
          updateFormula(formula.id, "pivotValues", selectedOptions.map(opt => opt.value))
        }
        className="text-sm w-64"
        placeholder="Select Value Fields"
      />
    </div>

    {/* Aggregation method */}
    <div>
      <label className="label1 mb-1">Aggregation</label><br />
      <Select
        options={[
          { value: "sum", label: "Sum" },
          { value: "count", label: "Count" },
          { value: "average", label: "Average" },
        ]}
        value={
          formula.pivotAggregation
            ? { value: formula.pivotAggregation, label: formula.pivotAggregation.charAt(0).toUpperCase() + formula.pivotAggregation.slice(1) }
            : null
        }
        onChange={(selectedOption) => updateFormula(formula.id, "pivotAggregation", selectedOption.value)}
        className="text-sm w-36"
      />
    </div>
  </div>
)}



{formula.selectedExcelFunction?.value === "concat" && (
  <div className="flex flex-wrap gap-3 pt-4" style={{ paddingRight: "5px", paddingTop: "5px", display: "flex" }}>

    {/* Reference File */}
    <div style={{ paddingRight: "5px" }}>
      <label className="label1 mb-1">Reference File</label><br />
      <Select
        options={fileOptions}
        value={fileOptions.find(opt => opt.value === formula.concatRefFile)}
        onChange={(selectedOption) => {
          updateFormula(formula.id, "concatRefFile", selectedOption.value);
        }}
        className="text-sm w-36"
      />
    </div>

    {/* Sheet Name Dropdown */}
    <div style={{ paddingRight: "5px" }}>
      <label className="label1 mb-1">Sheet</label><br />
      <Select
        options={
          fileDataList[formula.concatRefFile]?.sheetNames?.map(sheet => ({ value: sheet, label: sheet })) || []
        }
        value={
          fileDataList[formula.concatRefFile]?.selectedSheetPerFormula?.[`${formula.id}_concat`]
            ? {
                value: fileDataList[formula.concatRefFile].selectedSheetPerFormula[`${formula.id}_concat`],
                label: fileDataList[formula.concatRefFile].selectedSheetPerFormula[`${formula.id}_concat`],
              }
            : null
        }
        onChange={(selectedOption) => {
          const updatedFileData = [...fileDataList];
          if (!updatedFileData[formula.concatRefFile].selectedSheetPerFormula) {
            updatedFileData[formula.concatRefFile].selectedSheetPerFormula = {};
          }
          updatedFileData[formula.concatRefFile].selectedSheetPerFormula[`${formula.id}_concat`] = selectedOption.value;
          setFileDataList(updatedFileData);
        }}
        className="text-sm w-36"
        placeholder="Select Sheet"
      />
    </div>

    {/* Select Columns for Concat */}
    <div style={{ paddingRight: "5px" }}>
      <label className="label1 mb-1">Concat Columns</label><br />
      <Select
        isMulti
        options={
          (() => {
            const file = fileDataList[formula.concatRefFile];
            const sheet = file?.selectedSheetPerFormula?.[`${formula.id}_concat`];
            const row = file?.sheetData?.[sheet]?.[0];
            return row ? Object.keys(row).map(col => ({ value: col, label: col })) : [];
          })()
        }
        value={(formula.concatColumns || []).map(col => ({ value: col, label: col }))}
        onChange={(selectedOptions) =>
          updateFormula(
            formula.id,
            "concatColumns",
            selectedOptions.map(opt => opt.value)
          )
        }
        className="text-sm w-64"
        placeholder="Select columns to concat"
      />
    </div>
  </div>
)}


{formula.selectedExcelFunction?.value === "if" &&
  (formula.booleanConditions || []).map((cond, index) => (
    <div
      key={index}
      className="flex flex-wrap gap-4 pt-4 items-end border p-2 mb-2 rounded bg-gray-50"
      style = {{display:"flex"}}
    >
      {/* File A */}
      <div>
        <label className="label1 mb-1">File A</label><br />
        <Select
          options={fileOptions}
          value={fileOptions.find(opt => opt.value === cond.file)}
          onChange={(selected) => updateIfCondition(formula.id, index, "file", selected.value)}
          className="text-sm w-36"
        />
      </div>

      {/* Sheet A */}
      <div>
        <label className="label1 mb-1">Sheet A</label><br />
        <Select
          options={fileDataList[cond.file]?.sheetNames?.map(s => ({ value: s, label: s })) || []}
          value={cond.sheet ? { value: cond.sheet, label: cond.sheet } : null}
          onChange={(selected) => {
            const updated = [...fileDataList];
            if (!updated[cond.file].selectedSheetPerFormula) {
              updated[cond.file].selectedSheetPerFormula = {};
            }
            updated[cond.file].selectedSheetPerFormula[`${formula.id}_if_${index}`] = selected.value;
            setFileDataList(updated);
            updateIfCondition(formula.id, index, "sheet", selected.value);
          }}
          className="text-sm w-36"
        />
      </div>

      {/* Column A */}
      <div>
        <label className="label1 mb-1">Column A</label><br />
        <Select
          options={(() => {
            const file = fileDataList[cond.file];
            const sheet = file?.selectedSheetPerFormula?.[`${formula.id}_if_${index}`];
            const row = file?.sheetData?.[sheet]?.[0];
            return row ? Object.keys(row).map(col => ({ value: col, label: col })) : [];
          })()}
          value={cond.columnA ? { value: cond.columnA, label: cond.columnA } : null}
          onChange={(selected) => updateIfCondition(formula.id, index, "columnA", selected.value)}
          className="text-sm w-36"
        />
      </div>

      {/* Operator */}
      <div>
        <label className="label1 mb-1">Condition</label><br />
        <Select
          options={comparisonOperators}
          value={comparisonOperators.find(opt => opt.value === cond.condition) || null}
          onChange={(selected) => updateIfCondition(formula.id, index, "condition", selected.value)}
          className="text-sm w-48"
        />
      </div>

      {/* File B */}
      <div>
        <label className="label1 mb-1">Compare With File</label><br />
        <Select
          options={fileOptions}
          value={fileOptions.find(opt => opt.value === cond.compareFile)}
          onChange={(selected) => updateIfCondition(formula.id, index, "compareFile", selected.value)}
          className="text-sm w-36"
        />
      </div>

      {/* Sheet B */}
      <div>
        <label className="label1 mb-1">Compare With Sheet</label><br />
        <Select
          options={fileDataList[cond.compareFile]?.sheetNames?.map(s => ({ value: s, label: s })) || []}
          value={cond.compareSheet ? { value: cond.compareSheet, label: cond.compareSheet } : null}
          onChange={(selected) => {
            const updated = [...fileDataList];
            if (!updated[cond.compareFile].selectedSheetPerFormula)
              updated[cond.compareFile].selectedSheetPerFormula = {};
            updated[cond.compareFile].selectedSheetPerFormula[`${formula.id}_if_cmp_${index}`] = selected.value;
            setFileDataList(updated);
            updateIfCondition(formula.id, index, "compareSheet", selected.value);
          }}
          className="text-sm w-36"
        />
      </div>

      {/* Column B */}
      <div>
        <label className="label1 mb-1">Compare With Column</label><br />
        <Select
          options={(() => {
            const file = fileDataList[cond.compareFile];
            const sheet = file?.selectedSheetPerFormula?.[`${formula.id}_if_cmp_${index}`];
            const row = file?.sheetData?.[sheet]?.[0];
            return row ? Object.keys(row).map(col => ({ value: col, label: col })) : [];
          })()}
          value={cond.columnB ? { value: cond.columnB, label: cond.columnB } : null}
          onChange={(selected) => updateIfCondition(formula.id, index, "columnB", selected.value)}
          className="text-sm w-36"
        />
      </div>
<div>
        <Icon
          name="trash"
          style={{ cursor: "pointer", marginLeft: "10px", color: "red", paddingTop: "35px" }}
          onClick={() => removeIfConditionRow(formula.id, index)}
        />
</div>

    </div>
  ))
}

          {formula.selectedExcelFunction?.value === "numerical_operations" && (
            <div className="flex flex-wrap gap-3 pt-4" style = {{paddingRight: "5px",paddingTop: "5px"}}>
              {formula.columns.map((_, i) => (
                <div key={i} className="flex items-center gap-2" style = {{display:"flex",paddingRight: "5px"}}>

                  {i > 0 && (
                   <div>
                     <label className="label1 mb-1">Operations</label><br />
                     <Select
                       options={Operations}
                       value={formula.operations[i]}
                       onChange={(selectedOption) => {
                         const updated = [...formula.operations];
                         updated[i] = selectedOption;
                         updateFormula(formula.id, "operations", updated);
                       }}
                     />
                   </div>
                  )}
<div style={{ paddingRight: "5px"}}>
  <label className="label1 mb-1">Source Files</label><br />
  <Select
    options={fileOptions}
    value={fileOptions.find(option => option.value === formula.fileSources[i])}
    onChange={(selectedOption) => {
      const updated = [...formula.fileSources];
      updated[i] = selectedOption.value;
      updateFormula(formula.id, "fileSources", updated);
    }}
    className="text-sm w-36"
  />
</div>


<div style={{ paddingRight: "5px" }}>
  <label className="label1 mb-1">Sheet</label><br />
  <Select
    options={
      fileDataList[formula.fileSources[i]]?.sheetNames?.map(name => ({ value: name, label: name })) || []
    }
    value={
      fileDataList[formula.fileSources[i]]?.selectedSheetPerFormula?.[`${formula.id}_${i}`]
        ? {
            value: fileDataList[formula.fileSources[i]].selectedSheetPerFormula[`${formula.id}_${i}`],
            label: fileDataList[formula.fileSources[i]].selectedSheetPerFormula[`${formula.id}_${i}`],
          }
        : null
    }
    onChange={(selected) => {
      const updatedFileDataList = [...fileDataList];
      if (!updatedFileDataList[formula.fileSources[i]].selectedSheetPerFormula) {
        updatedFileDataList[formula.fileSources[i]].selectedSheetPerFormula = {};
      }
      updatedFileDataList[formula.fileSources[i]].selectedSheetPerFormula[`${formula.id}_${i}`] = selected.value;
      setFileDataList(updatedFileDataList);
    }}
    className="text-sm w-36"
  />
</div>

<div style={{ paddingRight: "5px" }}>
  <label className="label1 mb-1">Columns</label><br />
  <Select
    options={
      (() => {
        const file = fileDataList[formula.fileSources[i]];
        const sheet = file?.selectedSheetPerFormula?.[`${formula.id}_${i}`];
        const row = file?.sheetData?.[sheet]?.[0];
        return row ? Object.keys(row).map(col => ({ value: col, label: col })) : [];
      })()
    }
    value={
      formula.columns[i]
        ? { value: formula.columns[i], label: formula.columns[i] }
        : null
    }
    onChange={(selectedOption) => {
      const updated = [...formula.columns];
      updated[i] = selectedOption.value;
      updateFormula(formula.id, "columns", updated);
    }}
    placeholder="Select Column"
    className="text-sm w-36"
  />
</div>

                  {i > 0 && (
                  <Icon
                    name="trash"
                    style={{ cursor: "pointer", marginLeft: "10px", color: "red",paddingTop:"35px" }}
                    onClick={() => removeColumnPair(formula.id, i)}
                  />

                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
})}



<div style = {{display:"flex"}}>
      <div className="submit-row">
        <button type="submit" className="submit-btn" onClick={addFormula}>Add Formula</button>
      </div>

      <div className="submit-row">
        <button type="submit" className="submit-btn" onClick={handleDownload}>Download File</button>
      </div>

</div>
    </div>
  );
};

export default ExcelFormulaConfigurator;
